import React from 'react'
import {
  Typography, Grid, Checkbox
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { FlashOn } from '@material-ui/icons'

const FastFilterToggle = props => {
  const { newFormData, setFormData = () => {} } = props

  const GreenCheckbox = withStyles({
    root: {
      color: '#595959',
      '&$checked': {
        color: '#A4D164'
      }
    },
    checked: {}
  })((props) => <Checkbox color='default' {...props} />)

  return (
    <Grid item container direction='column'>
      <Grid item container direction='row' alignItems='center'>
        <GreenCheckbox
          checked={Boolean(newFormData?.isFastFilter)}
          onChange={e => setFormData({ ...newFormData, isFastFilter: !newFormData.isFastFilter })}
        />
        <Typography style={{ color: '#6A6A6A', fontWeight: 600, fontSize: '1.1rem' }} className='elevio-set-fast-filter'>
          Set as Fast Filter?
        </Typography>
        <FlashOn style={{ fontSize: '18px', color: newFormData?.isFastFilter ? '#f5d818' : '#B3B3B3', marginLeft: '.5em' }} />
      </Grid>
      <Grid item>
        <Typography style={{ fontSize: '12px', marginLeft: '2em' }}>Select this option to add this filter to your Fast Filter dropdown menu.</Typography>
      </Grid>
    </Grid>
  )
}

export default FastFilterToggle
